import ThreadsListContainer from '../ThreadsListContainer/ThreadsListContainer';

const AllThreads = () => {
  
  return (
    <ThreadsListContainer config={{ favoriteOnly: false }} />
  );
};

export default AllThreads;
